import { memo } from 'react';
import styled from 'styled-components';

import Button from '@components/Button/Button';
import Flag from '@components/Flag/Flag';

export const countries = [
  {
    code: 'AU',
    name: 'Australia',
  },
  {
    code: 'CA',
    name: 'Canada',
  },
  {
    code: 'DE',
    name: 'Germany',
  },
  {
    code: 'GB',
    name: 'United Kingdom',
  },
  {
    code: 'US',
    name: 'United States',
  },
];

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 2rem;
`;

const Option = styled.div`
  margin-bottom: 0.25rem;
  text-align: center;
  width: 50%;

  > * {
    width: 100%;
  }

  @media ${(props) => props.theme.breakpoints.lg} {
    margin-bottom: 0.5rem;
  }
`;

const CountrySelect = ({ onClick }) => {
  return (
    <Container>
      {countries.map((country) => (
        <Option key={country.code}>
          <Button
            analytics={{
              category: 'CountrySelect',
              action: 'click',
              label: 'Select Country',
              value: country.name,
            }}
            icon={
              <Flag countryCode={country.code} countryName={country.name} />
            }
            layout="icon-above"
            onClick={() => {
              onClick(country.code, country.name);
            }}
            smallFont={true}
            text={country.name}
            type="secondary"
          />
        </Option>
      ))}
    </Container>
  );
};

export default memo(CountrySelect);
